import React from 'react';
import { ALL_BUS, BU } from '../utils/featureRoleMatrix';
import { getDeptMeta } from './DeptBadge';

interface SharedWithDotsProps {
  targetBUs: BU[];
  size?: 'sm' | 'md';
}

function buildTooltip(targetBUs: BU[]): string {
  if (targetBUs.length === 3) return 'Common — visible in all business units';
  if (targetBUs.length === 2) return `Shared with ${targetBUs.join(', ')}`;
  if (targetBUs.length === 1) return `Exclusive to ${targetBUs[0]}`;
  return 'Not assigned to any business unit';
}

const SharedWithDots: React.FC<SharedWithDotsProps> = ({ targetBUs, size = 'sm' }) => {
  const targetSet = new Set(targetBUs);
  const dotSize = size === 'md' ? 'w-2 h-2' : 'w-1.5 h-1.5';

  return (
    <span
      className="inline-flex items-center gap-1 align-middle"
      title={buildTooltip(targetBUs)}
      aria-label={buildTooltip(targetBUs)}
    >
      {ALL_BUS.map(bu => {
        const filled = targetSet.has(bu);
        const meta = getDeptMeta(bu);
        return (
          <span
            key={bu}
            className={`${dotSize} rounded-full`}
            style={{ background: filled ? meta.style.dotColor : 'rgba(11,59,46,0.12)' }}
            aria-hidden
          />
        );
      })}
    </span>
  );
};

export default SharedWithDots;
